import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  templateUrl: './locked.component.html',
  styleUrls: ['./locked.component.scss'],
})
export class LockedComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  protected get lockMessage() {
    switch (this.route.snapshot.data['page']) {
      case 'closed': return 'Your account has been closed.';
      case 'suspended':
        const isMigrating = this.route.snapshot.queryParams['m'] === '1';
        const isIncomplete = this.route.snapshot.queryParams['m'] === '2';

        if (!isMigrating && !isIncomplete) {
          return 'Your account has been suspended.';
        }
        else if (isMigrating) {
          return 'Hang tight - we\'re migrating your account and will notify you via email once it\'s done. Thanks for your patience!'
        }
        else if (isIncomplete) {
          return 'Hang tight - your account is being processed! Please check your email for further instructions.'
        }
    }
  }

  // UI handlers
  protected onClickBackToSignIn = () => {
    this.router.navigateByUrl('/login');
  }
}